import { invalidateCartSummaryQuery } from './useCartSummaryQuery';
import { collapseGroups } from '../../store/grouping/actions';
import { invalidateShoppingCartProducts } from './useShoppingCartProducts';
import { invalidateCartGroupedItems } from './useCartGroupedItems';
import { failUpdateToCart } from '../../store/products/actionsCart';
import * as types from '../../store/constants';
import { ACTION_DECREASE, ACTION_INCREASE, ACTION_SET, GroupBy, GROUPBY_BUNDLES } from '../../store/constants';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { showNotification } from '../../store/notifications/actions';
import { invalidateCartAggregations } from '../../shop/cart/useCartAggregations';
import { http } from '../axios';
import { shopPrefix } from '../../config';
import { BulkActionResponse } from '../../store/api';

type Group = { key: GroupBy; id: string };

const changeAmountProduct = (
    group: Group,
    amount: number,
    command: typeof ACTION_SET | typeof ACTION_INCREASE | typeof ACTION_DECREASE
) => {
    if (group.key === GROUPBY_BUNDLES) {
        const pathParams = {
            bundleId: group.id
        };

        const body = { targetAmount: amount };

        switch (command) {
            case ACTION_DECREASE:
                return http.put<BulkActionResponse>(
                    `${shopPrefix}/v2/shoppingcart/bulk/quantity/bundle/:bundleId/decrease`,
                    body,
                    {
                        pathParams
                    }
                );
            case ACTION_INCREASE:
                return http.put<BulkActionResponse>(
                    `${shopPrefix}/v2/shoppingcart/bulk/quantity/bundle/:bundleId/increase`,
                    body,
                    {
                        pathParams
                    }
                );
            case ACTION_SET:
                return http.put<BulkActionResponse>(
                    `${shopPrefix}/v2/shoppingcart/bulk/quantity/bundle/:bundleId/setAmount`,
                    body,
                    {
                        pathParams
                    }
                );
        }
    } else {
        throw new Error('Not supported group ref for changing amount request');
    }
};
export const useChangeAmountGroupedItem = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const onSuccess = () => {
        invalidateCartSummaryQuery().then();
        invalidateShoppingCartProducts().then();
        invalidateCartGroupedItems().then();
        invalidateCartAggregations().then();
    };

    return {
        changeAmountGroupedItem: async (
            group: Group,
            amount: number,
            command: typeof ACTION_SET | typeof ACTION_INCREASE | typeof ACTION_DECREASE
        ) => {
            try {
                const apiCallback = await changeAmountProduct(group, amount, command);
                dispatch(collapseGroups());
                dispatch(showNotification(t('notifications.copyAmountChangeCartBulk.message')));
                onSuccess();
                return apiCallback.data;
            } catch (error) {
                dispatch(failUpdateToCart({ t, error, source: types.SOURCE_CART, onSuccess }));
                throw error;
            }
        }
    };
};
